import { render, staticRenderFns } from "./EcBadge.vue?vue&type=template&id=d102e858"
import script from "./EcBadge.vue?vue&type=script&lang=js"
export * from "./EcBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports